import React from "react";
import "./styles.css";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Form,
  Select,
  InputNumber,
  Radio,
  Button,
  DatePicker,
  Input,
  Space,
} from "antd";
const FormItem = Form.Item;
const Option = Select.Option;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

const GastosNegocios = () => {
  return (
    <div className="gastosdiv">
      <Form>
        <FormItem label="Formulario de los Gastos">Negocios</FormItem>
        <div className="title">
          <h1 className="ant-form-text">Negocios</h1>
        </div>
        <div className="top">
          <FormItem hasFeedback label="Billetera">
            {/* <span className="billetera">Billetera:</span> */}

            <Select placeholder="Caja" style={{ width: 200 }}>
              <Option value="cajaoficina">Caja Oficina</Option>
              <Option value="myriam">Myriam</Option>
              <Option value="gonzalo">Gonzalo</Option>
              <Option value="martin">Martin</Option>
              <Option value="sol">Sol</Option>
            </Select>
          </FormItem>
          {/* <span className="fit">Fecha:</span> */}

          <FormItem label="Fecha">
            <DatePicker disableFuture />
          </FormItem>
        </div>
        <div className="bottom">
          <Form.List name="users">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <Space
                    key={key}
                    style={{
                      align: "end",
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 4,
                    }}
                    // align="baseline"
                  >
                    <FormItem
                      label="Nombre"
                      {...restField}
                      name={[name, "first"]}
                      rules={[
                        { required: true, message: "Missing first name" },
                      ]}
                    >
                      <Input placeholder="Nombre" style={{ width: 200 }} />
                    </FormItem>

                    <FormItem hasFeedback label="Categoria" name="categoria">
                      {/* <span className="ant-form-text">Categoria de Gasto:</span> */}
                      <Select
                        placeholder="Area"
                        style={{ width: 200, padding: 0 }}
                      >
                        <Option value="alquileres">Alquileres</Option>
                        <Option value="limpieza">Limpieza</Option>
                        <Option value="congelados">Productos Congelados</Option>
                        <Option value="sueldos">Sueldos</Option>
                      </Select>
                    </FormItem>

                    <FormItem label="Item" name="item">
                      {/* <span className="ant-form-text">Item:</span> */}
                      {
                        <Select placeholder="Detalle" style={{ width: 200 }}>
                          <Option value="chipa">Chipa Congelado</Option>
                          <Option value="energia">Energia</Option>
                          <Option value="alquilerlasheras">Las Heras</Option>
                        </Select>
                      }
                    </FormItem>
                    {/* <span className="fit">Monto:</span> */}
                    <FormItem label="Monto" name="monto">
                      <InputNumber
                        min={1}
                        max={20000000}
                        placeholder="$"
                        style={{ width: 150 }}
                      />
                    </FormItem>
                    <div className="minus">
                      <MinusCircleOutlined
                        onClick={() => remove(name)}
                        style={{
                          display: "flex",

                          justifyContent: "flex-end",
                        }}
                      />
                    </div>
                  </Space>
                ))}
                <div className="addFields">
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}
                      style={{
                        width: 200,
                        alignItems: "center",
                      }}
                    >
                      Add field
                    </Button>
                  </Form.Item>
                </div>
              </>
            )}
          </Form.List>

          <div className="addBtn">
            <FormItem wrapperCol={{ span: 12, offset: 6 }}>
              <Button type="primary" htmlType="submit">
                Agregar
              </Button>
            </FormItem>
          </div>
        </div>
      </Form>
    </div>
  );
};
export default GastosNegocios;
